'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.profile', {
    url: '/profile',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow('instance.app.profile');
      }
    },
    templateUrl: '/app/states/profile/profile.html',
    controller: function ($scope, $window, $state, $http, $timeout, $popup, $preloader, Api) {
      $scope.date = new Date();
      $scope.months = [
        'January', 'February', 'March', 'April', 'May',
        'June', 'July', 'August', 'September', 'October', 'November', 'December'
      ];
      $scope.user.dates.enrollment = _.isObject($scope.user.dates.enrollment) ? $scope.user.dates.enrollment : { year: 2020 };
      $scope.user.dates.graduation = _.isObject($scope.user.dates.graduation) ? $scope.user.dates.graduation : { year: 2015 };

      $scope.user.internships = $scope.user.internships || [];
      $scope.user.hasInternship = !!$scope.user.internships.length;
      $scope.$watch('user.hasInternship', function (hasInternship, prev) {
        if (hasInternship === prev) { return; }
        if (hasInternship) {
          $scope.user.internships = [{}, {}];
        } else {
          $scope.user.internships.length = 0;
        }
      });

      $scope.avatar = function () {
        if (!$window.FileReader || !$window.Blob) {
          $popup('prompt', {
            message: 'Your Browser doesn\'t support this feature.'
          });
        } else {
          $popup('avatar', { url: $scope.user.avatar }).then(function (avatar) {
            $scope.user.avatar = avatar;
            return $http.put('/api/v1/me', { avatar: avatar });
          });
        }
      };

      $scope.save = function () {
        $preloader.show();
        $http.put('/api/v1/me', $scope.user)
          .finally(function () {
            $preloader.hide();
            $timeout(function () {
              $scope.message = '';
            }, 5000);
          })
          .then(function () {
            return Api.track('user.profile', 'pass');
          })
          .then(function () {
            $scope.profile.$setPristine();
            $scope.user.flowPassed = _.get($scope.user, 'meta.profileCompleted', false) && $scope.user.persona;
            if (!$scope.user.persona) {
              $state.go('instance.app.assessmentQuiz');
            } else {
              $popup('prompt', { message: 'Your Profile was Successfully Updated' });
            }
          })
          .catch(function (response) {
            if (response.status == 400) {
              if (_.get(response, 'data.errors.email', null)) {
                $popup('prompt', { message: 'Your email address has already been used.' });
              }
            }
            $scope.message = 'Something went wrong';
          });
      };
    }
  });

});
